const colors = {
    // Primary Brand Colors
    appYellow: "#fed537",
    appGold: "#DAA520",
    appLightGold: "#FFD700",
    appDarkGold: "#B8860B",

    // Blues
    appLightestBlue: "#67bae7",
    appLightBlue: "#0094c9",
    appDarkBlue: "#32549B",
    appDarkestBlue: "#232d71",
    appAegeanBlue: "#1E4C8C",
    appSantoriniBlue: "#3D7DB2",
    appMediterraneanBlue: "#1A5F7A",

    // Pinks
    appPink: "#FF1493",
    appLightPink: "#ffb3db",
    appDarkPink: "#C71585",
    appRosePink: "#FF69B4",
    appBlushPink: "#FEC5E5",

    // Oranges & Warm Colors
    appOrange: "#ff6c4d",
    appLightOrange: "#FFA07A",
    appDarkOrange: "#FF4500",
    appTerracotta: "#E2725B",

    // Greens
    appOlive: "#808000",
    appLightOlive: "#A8B545",
    appDarkOlive: "#556B2F",
    appSage: "#9CAF88",
    appMediterraneanGreen: "#3C6E47",
    appEmerald: "#50C878",
    appForest: "#228B22",
    appMint: "#98FF98",

    // Platform Brand Colors
    appViatorOrange: "#FF8C00",
    appGetYourGuideRed: "#FF0000",
    appAirbnbCoral: "#FF385C",

    // Neutrals
    appWhite: "#FFFFFF",
    appOffWhite: "#F5F5F5",
    appParchment: "#F3ECD6",
    appGray100: "#F8F9FA",
    appGray200: "#E9ECEF",
    appGray300: "#DEE2E6",
    appGray400: "#CED4DA",
    appGray500: "#ADB5BD",
    appGray600: "#6C757D",
    appGray700: "#495057",
    appGray800: "#343A40",
    appGray900: "#212529",
    appBlack: "#000000",

    // Utility Colors
    appSuccess: "#28A745",
    appDanger: "#DC3545",
    appWarning: "#FFC107",
    appInfo: "#17A2B8",

    // Borders
    appBorder: "3px solid #fed537",
    appLightBorder: "1px solid #DEE2E6",
    appDarkBorder: "1px solid #343A40",

    // Overlay & Transparency
    appOverlayDark: "rgba(0, 0, 0, 0.7)",
    appOverlayLight: "rgba(255, 255, 255, 0.7)",
    appTransparentBlue: "rgba(50, 84, 155, 0.8)",
    appTransparentGold: "rgba(218, 165, 32, 0.6)"
};

export default colors;


